import React from "react";

const MobileContstruction = props => (
  <svg width={258} height={197} {...props}>
    <title>{"null_graphic_mobile"}</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="M245.875 193.958h-85a6.625 6.625 0 1 1 0-13.25h85a6.625 6.625 0 1 1 0 13.25"
        fill="#FAFAFA"
      />
      <path
        d="M229.82 89.7h-.722a3.87 3.87 0 0 0 .12-.944c0-2.006-1.525-3.632-3.406-3.632a3.24 3.24 0 0 0-1.854.587c-.487-3.43-2.844-6.03-5.68-6.03-3.033 0-5.52 2.976-5.755 6.758a2.185 2.185 0 0 0-1.2-.37c-1.515 0-2.74 1.625-2.74 3.632h-1.151c-1.89 0-3.432 1.68-3.432 3.735v.275c0 2.053 1.543 3.733 3.432 3.733h22.387c1.887 0 3.432-1.68 3.432-3.733v-.275c0-2.055-1.545-3.735-3.432-3.735M43.7 84.01h-1.22a6.537 6.537 0 0 0 .204-1.6c0-3.396-2.583-6.147-5.767-6.147a5.476 5.476 0 0 0-3.137.993c-.825-5.804-4.815-10.207-9.614-10.207-5.134 0-9.34 5.038-9.74 11.439-.616-.398-1.301-.628-2.031-.628-2.564 0-4.64 2.753-4.64 6.15H5.807C2.612 84.01 0 86.853 0 90.328v.465c0 3.477 2.612 6.321 5.807 6.321h37.892c3.194 0 5.808-2.844 5.808-6.32v-.466c0-3.475-2.614-6.32-5.808-6.32"
        fill="#EAF7FC"
        opacity={0.3}
      />
      <path fill="#F58525" d="M122.853 137.783h13.598v-1.443h-13.598z" />
      <path fill="#FE9840" d="M130.677 124.333h-2.05l-3.72 12.035h9.49z" />
      <path
        fill="#FFF"
        d="M125.661 133.933h7.982l-.743-2.405h-6.496zM127.892 126.717l-.743 2.405h5.009l-.745-2.405z"
      />
      <path
        d="M114.143 178.045h13.708v-13.708h-13.708v13.708zm-.741.742h15.19v-15.191h-15.19v15.191z"
        fill="#B0E3F4"
      />
      <path
        fill="#B0E3F4"
        d="M127.917 178.653l-14.298-14.298.525-.524 14.297 14.298z"
      />
      <path
        fill="#B0E3F4"
        d="M114.144 178.653l-.524-.524 14.297-14.298.525.524z"
      />
      <path
        d="M121.557 163.588h13.708V149.88h-13.708v13.708zm-.742.741h15.191v-15.19h-15.191v15.19z"
        fill="#B0E3F4"
      />
      <path
        fill="#B0E3F4"
        d="M135.331 164.196l-14.298-14.298.525-.524 14.297 14.298z"
      />
      <path
        fill="#B0E3F4"
        d="M121.558 164.196l-.524-.524 14.297-14.298.525.524zM128.6 178.045h13.708v-13.708H128.6v13.708zm-.741.742h15.19v-15.191h-15.19v15.191z"
      />
      <path
        fill="#B0E3F4"
        d="M142.374 178.653l-14.297-14.298.524-.524 14.297 14.298z"
      />
      <path
        fill="#B0E3F4"
        d="M128.6 178.653l-.522-.524 14.296-14.298.525.524z"
      />
      <path fill="#23C991" d="M118.174 140.427h20.76v-2.595h-20.76z" />
      <path
        fill="#86E0C2"
        d="M119.842 140.427h.742v-1.621h-.742zM133.373 139.94h.741v-1.622h-.741zM135.365 139.94h.741v-1.622h-.741z"
      />
      <path
        fill="#23C991"
        d="M119.355 163.627l-5.105-.511 1.55-15.492 5.106.51z"
      />
      <path
        fill="#86E0C2"
        d="M118.668 158.104l-2.428-.243.774-7.723 2.427.243z"
      />
      <path fill="#FE9840" d="M122.111 149.155h15.199v-4.465h-15.199z" />
      <path
        fill="#FEC391"
        d="M130.058 147.93h.742v-2.017h-.742zM135.631 147.93h.741v-2.017h-.741zM128.744 147.93h.741v-2.017h-.741zM127.43 147.93h.741v-2.017h-.741z"
      />
      <path fill="#00A7DB" d="M121.277 144.865h19.276v-4.389h-19.276z" />
      <path
        fill="#75CFEC"
        d="M122.637 143.783h.741v-2.225h-.741zM126.143 143.782h9.609v-2.224h-9.609z"
      />
      <path
        fill="#B0E3F4"
        d="M95.799 119.132L84.29 87.11l.698-.25 11.508 32.02z"
      />
      <path
        fill="#B0E3F4"
        d="M75.938 100.707l-.606-.426 9.506-13.51.606.428z"
      />
      <path fill="#B0E3F4" d="M84.77 87.653h.742V37.621h-.742z" />
      <path
        d="M82.639 86.485a2.502 2.502 0 1 0 5.003 0 2.502 2.502 0 0 0-5.003 0"
        fill="#FEAD64"
      />
      <path
        fill="#75CFEC"
        d="M100.064 120.908L72.529 97.899l-1.925 2.304 27.534 23.008z"
      />
      <path
        d="M251.842 187.268a5.187 5.187 0 0 1-5.187 5.187h-85.833a5.187 5.187 0 0 1 0-10.373h85.833a5.186 5.186 0 0 1 5.187 5.186m-3.423-9.005h-89.36a9.004 9.004 0 0 0-9.005 9.005 9.005 9.005 0 0 0 9.005 9.006h89.36a9.005 9.005 0 0 0 9.005-9.006 9.004 9.004 0 0 0-9.005-9.005"
        fill="#FEAD64"
      />
      <path fill="#FEAD64" d="M163.463 187.639h80.552v-.741h-80.552z" />
      <path
        d="M166.215 187.268a2.502 2.502 0 1 1-5.003.001 2.502 2.502 0 0 1 5.003 0M186.227 187.268a2.502 2.502 0 1 1-5.003.001 2.502 2.502 0 0 1 5.004 0M206.24 187.268a2.502 2.502 0 1 1-5.003.001 2.502 2.502 0 0 1 5.003 0M226.253 187.268a2.502 2.502 0 1 1-5.003.001 2.502 2.502 0 0 1 5.003 0M246.266 187.268a2.502 2.502 0 1 1-5.004.001 2.502 2.502 0 0 1 5.004 0"
        fill="#F58525"
      />
      <path
        d="M171.71 174.845h16.36v-21.446h-7.388l-8.971 8.385v13.06zm17.103.74H170.97v-14.123l9.419-8.805h8.424v22.929zM191.6 174.845h48.17v-20.443a5.68 5.68 0 0 0-5.673-5.673H191.6v26.116zm48.91.74H190.86v-27.597h43.238a6.42 6.42 0 0 1 6.414 6.414v21.184z"
        fill="#B0E3F4"
      />
      <path fill="#B0E3F4" d="M175.125 171.973h9.359v-9.454h-9.359z" />
      <path fill="#75CFEC" d="M175.125 171.973h4.819v-9.454h-4.819z" />
      <path
        fill="#23C991"
        d="M214.571 174.338h.741v-25.483h-.741zM212.07 174.338h.741v-25.483h-.741z"
      />
      <path fill="#B0E3F4" d="M199.475 170.271h27.839v-17.31h-27.839z" />
      <path fill="#EAF7FC" d="M202.222 167.39h22.346v-11.765h-22.346z" />
      <path
        fill="#23C991"
        d="M205.388 159.086h16.014v-.741h-16.014zM205.388 161.967h16.014v-.741h-16.014zM205.388 164.848h16.014v-.741h-16.014zM169.08 176.639h73.54v-2.659h-73.54z"
      />
      <path fill="#C0EADB" d="M193.86 147.69l-.642-.37 11.897-20.66.642.37z" />
      <path
        fill="#C0EADB"
        d="M222.073 139.887l-40.859-4.502.081-.737 40.86 4.502z"
      />
      <path
        fill="#C0EADB"
        d="M181.718 134.738l-.593-.445 13.008-17.344.594.444z"
      />
      <path
        fill="#C0EADB"
        d="M203.04 125.375l-37.858-6.504.125-.73 37.857 6.504zM164.54 117.394l-.593-.446 10.173-13.508.593.445z"
      />
      <path
        fill="#C0EADB"
        d="M186.857 113.2l-32.688-6.004.134-.729 32.69 6.004z"
      />
      <path fill="#C0EADB" d="M154.39 107.02l-.64-.377 7.673-13.009.639.377z" />
      <path
        fill="#C0EADB"
        d="M172.362 102.362l-26.517-3.836.107-.733 26.516 3.836z"
      />
      <path fill="#C0EADB" d="M146.193 98.55l-.59-.448 9.745-12.81.591.449z" />
      <path
        fill="#C0EADB"
        d="M160.338 93.186l-24.35-4.669.14-.728 24.35 4.67zM134.07 85.951l-.692-.266 3.836-10.006.692.265z"
      />
      <path
        fill="#C0EADB"
        d="M145.22 81.852l-16.307-.479.023-.742 16.306.48zM128.275 80.597l-2-13.701.733-.109 2 13.703z"
      />
      <path
        fill="#C0EADB"
        d="M136.185 75.18l-14.918-1.63.082-.737 14.916 1.63zM120.694 72.788l-2.177-11.08.728-.143 2.177 11.08z"
      />
      <path
        fill="#C0EADB"
        d="M125.022 66.509l-11.553-.915.06-.74 11.553.916zM112.887 64.835l-2.121-10.296.725-.15 2.122 10.296z"
      />
      <path fill="#C0EADB" d="M116.52 60.338l-8.98-.656.054-.74 8.98.657z" />
      <path
        fill="#55D5A9"
        d="M193.726 148.47L84.453 36.106l.532-.517 109.273 112.363z"
      />
      <path
        fill="#55D5A9"
        d="M233.856 148.633L85.401 36.493l.447-.59L234.303 148.04z"
      />
      <path
        d="M87.847 36.322a2.503 2.503 0 1 1-2.892-2.039 2.503 2.503 0 0 1 2.892 2.04"
        fill="#FEAD64"
      />
      <path
        fill="#23C991"
        d="M100.621 57.467h14.145v-3.002h-14.145zM130.263 88.236h27.018v-3.002h-27.018zM160.617 118.756h37.524v-3.002h-37.524z"
      />
      <path
        fill="#75CFEC"
        d="M21.928 174.983h2.224v-26.586h-2.224zM101.998 174.983h2.225v-26.586h-2.225z"
      />
      <path fill="#23C991" d="M26.149 174.902h6.313v-20.76h-6.313z" />
      <path
        fill="#86E0C2"
        d="M26.149 156.553h3.946v-.742h-3.946zM27.332 170.083h3.946v-.741h-3.946zM27.332 172.075h3.946v-.741h-3.946z"
      />
      <path fill="#FE9840" d="M40.354 174.902h8.286v-19.276h-8.286z" />
      <path
        fill="#FEC391"
        d="M41.932 164.584h5.13v-.741h-5.13zM41.932 157.912h5.13v-.742h-5.13zM41.932 166.577h5.13v-.742h-5.13z"
      />
      <path fill="#FE9840" d="M77.361 174.902h3.157v-23.725h-3.157z" />
      <path
        fill="#FEC391"
        d="M78.225 162.29h1.427v-.741h-1.427zM78.225 153.591h1.427v-.741h-1.427zM78.225 164.341h1.427v-.741h-1.427zM78.225 166.392h1.427v-.741h-1.427z"
      />
      <path fill="#00A7DB" d="M33.906 174.902h4.735V152.66h-4.735z" />
      <path
        fill="#75CFEC"
        d="M35.879 155.347h2.762v-.741h-2.762zM35.287 168.168h1.973v-8.773h-1.973z"
      />
      <path
        fill="#00A7DB"
        d="M68.976 172.455l-6.603 2.615-8.055-20.334 6.603-2.615z"
      />
      <path
        fill="#75CFEC"
        d="M55.318 157.263l-.272-.688 4.768-1.89.274.69zM56.001 158.987l-.272-.689 4.768-1.89.274.69zM62.748 171.466l-.272-.69 3.668-1.453.273.69z"
      />
      <path
        fill="#23C991"
        d="M58.54 174.054l-4.999 1.159-4.688-20.222 5-1.16z"
      />
      <path
        fill="#86E0C2"
        d="M50.555 156.213l-.167-.723 2.307-.534.167.723zM51.005 158.154l-.167-.723 2.306-.534.168.722zM56.938 173.11l-2.376.55-1.332-5.75 2.377-.55z"
      />
      <path fill="#23C991" d="M70.498 174.902h5.13v-19.276h-5.13z" />
      <path fill="#86E0C2" d="M71.956 168.182h2.439v-9.608h-2.439z" />
      <path fill="#FE9840" d="M76.439 139.536h19.276v-5.921H76.439z" />
      <path
        fill="#FEC391"
        d="M86.758 138.408h.741v-3.665h-.741zM93.43 138.408h.741v-3.665h-.741zM84.765 138.408h.741v-3.665h-.741z"
      />
      <path fill="#00A7DB" d="M72.189 133.629h22.242v-4.735H72.189z" />
      <path
        fill="#75CFEC"
        d="M91.744 133.63h.741v-2.762h-.741zM78.924 132.249h8.773v-1.973h-8.773z"
      />
      <path fill="#23C991" d="M73.857 144.669h19.276v-5.13H73.857z" />
      <path fill="#86E0C2" d="M80.577 143.435h9.608v-2.439h-9.608z" />
      <path
        fill="#23C991"
        d="M98.536 174.923l-7.034-.99 3.045-21.657 7.034.989z"
      />
      <path
        fill="#86E0C2"
        d="M98.098 155.52l-3.98-.56.105-.734 3.979.56zM97.42 171.521l-3.907-.55.103-.734 3.908.55zM97.214 172.99l-3.908-.55.103-.734 3.909.55z"
      />
      <path fill="#00A7DB" d="M87.037 174.902h4.389v-19.276h-4.389z" />
      <path
        fill="#75CFEC"
        d="M88.119 173.543h2.225v-.742h-2.225zM88.119 170.036h2.225v-9.608h-2.225z"
      />
      <path fill="#00A7DB" d="M81.758 174.902h3.157V152.66h-3.157z" />
      <path
        fill="#75CFEC"
        d="M82.595 156.676h1.483v-.741h-1.483zM82.595 155.054h1.483v-.741h-1.483zM82.595 167.935h1.483v-9.609h-1.483z"
      />
      <path
        fill="#3BBAE3"
        d="M21.928 178.547h82.334v-3.707H21.928zM21.928 148.428h82.334v-3.707H21.928z"
      />
      <path
        d="M178.845 21.882h-3.134c.08-.417.125-.844.125-1.283 0-3.862-3.194-6.993-7.136-6.993a7.202 7.202 0 0 0-3.956 1.174C164.544 7.056 157.7.847 149.283.847c-6.77 0-12.523 4.018-14.62 9.61-1.256-1.509-2.903-2.43-4.71-2.43-3.936 0-7.128 4.338-7.128 9.69 0 1.492.256 2.902.701 4.165h-.81c-3.694 0-6.716 3.023-6.716 6.717 0 3.695 3.022 6.716 6.716 6.716h56.129c3.692 0 6.716-3.021 6.716-6.716 0-3.694-3.024-6.717-6.716-6.717"
        fill="#EAF7FC"
        opacity={0.3}
      />
    </g>
  </svg>
);

export default MobileContstruction;
